import { StorageService } from './../../../../shared/services/storage/storage.service';
import { Component, OnInit, Inject, Input } from '@angular/core';
import { UtilService, EventsService } from '../../../../shared/services';
import { DOCUMENT } from '@angular/common';
import { SignupService } from '../../../../shared/services/signup/signup.service';

@Component({
  selector: 'app-startfundraiser-button',
  templateUrl: './startfundraiser-button.component.html',
  styleUrls: ['./startfundraiser-button.component.scss']
})
export class StartfundraiserButtonComponent implements OnInit {
  @Input() public pageName;
  @Input() public info2;
  @Input() public info;
  @Input() public width;
  @Input() public height;
  @Input() public font;
  @Input() public lineHeight;
  @Input() public label;
  @Input() public platformFee;
  constructor(
    public utilService: UtilService,
    @Inject(DOCUMENT) private document: any,
    private signupService: SignupService,
    private storageService: StorageService,
    public eventsService: EventsService
  ) { }

  ngOnInit() {
  }

  /*Event for start a fundraiser banner button */
  sendEvent(language) {
    this.storageService.add('language', language);
    this.eventsService.userGTMEvents({
      event: 'start_fundraiser',
      event_category: 'cta',
      event_action: 'start a fundraiser',
      event_label: `${this.label}|${window.location.href}`
    });
    if (language === 'Hindi') {
      this.pageName = 'home';
      this.info2 = 'home_1_hindi';

    }
    const payload = {
      eventName: 'start_a_campaign_initiated',
      event_type: 'campaign',
      page_name: this.pageName,
      referrer_page: this.document.referrer,
      info_1: 'type',
      info_2: this.info2,
      event_type_id: ''
    };
    this.eventsService.sendSystemEvent(payload).subscribe(_ => _);
    this.storageService.checkFromSession('sac-initiated', payload);
    this.signupService.startFR();
  }

}
